// Dashboard formatting functions
// Extracted from AdminIATab.tsx

export const fmtTokens = (n: number): string => {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${Math.round(n / 1000)}K`;
  return String(n);
};

export const fmtEuros = (n: number): string => `${n.toFixed(2)} \u20AC`;

export const fmtLatencia = (ms: number): string => `${(ms / 1000).toFixed(1)}s`;

export const getPeriodLabel = (periodo: string): string => {
  const now = new Date();
  switch (periodo) {
    case 'este_mes':
      return now.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
    case 'mes_anterior':
      return new Date(now.getFullYear(), now.getMonth() - 1, 1).toLocaleDateString('es-ES', {
        month: 'long',
        year: 'numeric',
      });
    case '7_dias':
      return 'ultimos 7 dias';
    case '30_dias':
      return 'ultimos 30 dias';
    case '90_dias':
      return 'ultimos 90 dias';
    case 'todo':
      return 'historico completo';
    default:
      return '';
  }
};
